import * as R from 'ramda';

export const getTagClause = R.ifElse(R.equals('All'), R.always(null), name => ({
  tags: { tag: { name: { _in: [name] } } },
}));

export const getCategoryClause = R.ifElse(R.equals('All'), R.always(null), name => ({
  category: { name: { _in: [name] } },
}));

export const getTitleClause = R.ifElse(R.isEmpty, R.always(null), name => ({
  name: { _ilike: `%${name}%` },
}));
